export function throw404(statusText = 'Page not found'): never {
  throw new Response(statusText, {
    status: 404,
    statusText,
  });
}
